//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const USERS_API_BASE_URL = new InjectionToken<string>('USERS_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class UsersApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(USERS_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getGroups(type?: string | undefined): Observable<GroupResponseModel[]> {
        let url_ = this.baseUrl + "/api/groups?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupResponseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupResponseModel[]>;
        }));
    }

    protected processGetGroups(response: HttpResponseBase): Observable<GroupResponseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param applicationName (optional) 
     * @param includePermissions (optional) 
     * @param includeRolePermissions (optional) 
     * @param includeExternalKeyPermissions (optional) 
     * @param includeUserGroups (optional) 
     * @return Success
     */
    getUser(applicationName?: string | undefined, includePermissions?: boolean | undefined, includeRolePermissions?: boolean | undefined, includeExternalKeyPermissions?: boolean | undefined, includeUserGroups?: boolean | undefined): Observable<UserResponseModel> {
        let url_ = this.baseUrl + "/api/me?";
        if (applicationName === null)
            throw new Error("The parameter 'applicationName' cannot be null.");
        else if (applicationName !== undefined)
            url_ += "applicationName=" + encodeURIComponent("" + applicationName) + "&";
        if (includePermissions === null)
            throw new Error("The parameter 'includePermissions' cannot be null.");
        else if (includePermissions !== undefined)
            url_ += "includePermissions=" + encodeURIComponent("" + includePermissions) + "&";
        if (includeRolePermissions === null)
            throw new Error("The parameter 'includeRolePermissions' cannot be null.");
        else if (includeRolePermissions !== undefined)
            url_ += "includeRolePermissions=" + encodeURIComponent("" + includeRolePermissions) + "&";
        if (includeExternalKeyPermissions === null)
            throw new Error("The parameter 'includeExternalKeyPermissions' cannot be null.");
        else if (includeExternalKeyPermissions !== undefined)
            url_ += "includeExternalKeyPermissions=" + encodeURIComponent("" + includeExternalKeyPermissions) + "&";
        if (includeUserGroups === null)
            throw new Error("The parameter 'includeUserGroups' cannot be null.");
        else if (includeUserGroups !== undefined)
            url_ += "includeUserGroups=" + encodeURIComponent("" + includeUserGroups) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserResponseModel>;
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<UserResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    audit(body?: AuditUserCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/me/audit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAudit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAudit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAudit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    clearCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/me/clearcache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUser(body?: CreateUserCommand | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUserById(id: string): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addPermissionToUser(body?: AddUserPermissionRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/User/Permission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPermissionToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPermissionToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddPermissionToUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertUserV2(body?: UpsertUserCommandV2 | undefined): Observable<UsersResponse> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertUserV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertUserV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsersResponse>;
        }));
    }

    protected processUpsertUserV2(response: HttpResponseBase): Observable<UsersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = UsersResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param applicationName (optional) 
     * @param includePermissions (optional) 
     * @param includeRolePermissions (optional) 
     * @param includeExternalKeyPermissions (optional) 
     * @param includeUserGroups (optional) 
     * @return Success
     */
    getUserByUserId(userId: string, applicationName?: string | undefined, includePermissions?: boolean | undefined, includeRolePermissions?: boolean | undefined, includeExternalKeyPermissions?: boolean | undefined, includeUserGroups?: boolean | undefined): Observable<UserResponseModel> {
        let url_ = this.baseUrl + "/api/Users/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (applicationName === null)
            throw new Error("The parameter 'applicationName' cannot be null.");
        else if (applicationName !== undefined)
            url_ += "applicationName=" + encodeURIComponent("" + applicationName) + "&";
        if (includePermissions === null)
            throw new Error("The parameter 'includePermissions' cannot be null.");
        else if (includePermissions !== undefined)
            url_ += "includePermissions=" + encodeURIComponent("" + includePermissions) + "&";
        if (includeRolePermissions === null)
            throw new Error("The parameter 'includeRolePermissions' cannot be null.");
        else if (includeRolePermissions !== undefined)
            url_ += "includeRolePermissions=" + encodeURIComponent("" + includeRolePermissions) + "&";
        if (includeExternalKeyPermissions === null)
            throw new Error("The parameter 'includeExternalKeyPermissions' cannot be null.");
        else if (includeExternalKeyPermissions !== undefined)
            url_ += "includeExternalKeyPermissions=" + encodeURIComponent("" + includeExternalKeyPermissions) + "&";
        if (includeUserGroups === null)
            throw new Error("The parameter 'includeUserGroups' cannot be null.");
        else if (includeUserGroups !== undefined)
            url_ += "includeUserGroups=" + encodeURIComponent("" + includeUserGroups) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserResponseModel>;
        }));
    }

    protected processGetUserByUserId(response: HttpResponseBase): Observable<UserResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    deleteUser(userId: string): Observable<IResponse> {
        let url_ = this.baseUrl + "/api/Users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IResponse>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<IResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = IResponse.fromJS(resultData204);
            return _observableOf(result204);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    auditUser(userId: string, body?: AuditUserCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/audit";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuditUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuditUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAuditUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    clearUserCache(userId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/clearcache";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearUserCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearUserCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearUserCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUserCompanies(userId: string): Observable<UserCompanyMappingDto[]> {
        let url_ = this.baseUrl + "/api/Users/{userId}/companies";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCompanyMappingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCompanyMappingDto[]>;
        }));
    }

    protected processGetUserCompanies(response: HttpResponseBase): Observable<UserCompanyMappingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserCompanyMappingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignUserCompany(userId: string, body?: AssignUserCompanyCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/companies";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignUserCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignUserCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignUserCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unAssignUserCompany(userId: string, body?: UnAssignUserCompanyCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/companies";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnAssignUserCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnAssignUserCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnAssignUserCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUserGroupsByUserId(userId: string): Observable<UserResponseModel> {
        let url_ = this.baseUrl + "/api/Users/{userId}/groups";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserGroupsByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserGroupsByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserResponseModel>;
        }));
    }

    protected processGetUserGroupsByUserId(response: HttpResponseBase): Observable<UserResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignUserGroups(userId: string, body?: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/groups";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignUserGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignUserGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignUserGroups(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unassignUserGroups(userId: string, body?: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/groups";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignUserGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignUserGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignUserGroups(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUserPermission(userId: string): Observable<UserPermissionDto> {
        let url_ = this.baseUrl + "/api/Users/{userId}/permissions";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPermissionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPermissionDto>;
        }));
    }

    protected processGetUserPermission(response: HttpResponseBase): Observable<UserPermissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPermissionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUserRoles(userId: string): Observable<UsersRolesDto[]> {
        let url_ = this.baseUrl + "/api/Users/{userId}/roles";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsersRolesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsersRolesDto[]>;
        }));
    }

    protected processGetUserRoles(response: HttpResponseBase): Observable<UsersRolesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UsersRolesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignRolesToUsers(userId: string, body?: UserRoleDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/roles";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignRolesToUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignRolesToUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignRolesToUsers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    unassignUserRole(userId: string, body?: RoleIdDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/roles";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignUserRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    setPrimaryRole(userId: string, roleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/roles/{roleId}/setprimary";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPrimaryRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPrimaryRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetPrimaryRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param application (optional) 
     * @param includeSuperAdmin (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllUsers(application?: string | undefined, includeSuperAdmin?: boolean | undefined, body?: FilterRequest | undefined): Observable<UserWithRolesDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/Users/getAllUsers?";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "application=" + encodeURIComponent("" + application) + "&";
        if (includeSuperAdmin === null)
            throw new Error("The parameter 'includeSuperAdmin' cannot be null.");
        else if (includeSuperAdmin !== undefined)
            url_ += "includeSuperAdmin=" + encodeURIComponent("" + includeSuperAdmin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWithRolesDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWithRolesDtoGridResponseBase>;
        }));
    }

    protected processGetAllUsers(response: HttpResponseBase): Observable<UserWithRolesDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserWithRolesDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param applicationName (optional) 
     * @param includePermissions (optional) 
     * @param includeRolePermissions (optional) 
     * @param includeExternalKeyPermissions (optional) 
     * @param includeUserGroups (optional) 
     * @param body (optional) 
     * @return Success
     */
    getUserByClaim(applicationName?: string | undefined, includePermissions?: boolean | undefined, includeRolePermissions?: boolean | undefined, includeExternalKeyPermissions?: boolean | undefined, includeUserGroups?: boolean | undefined, body?: UserClaimRequest | undefined): Observable<UserResponseModel> {
        let url_ = this.baseUrl + "/api/Users/getbyclaim?";
        if (applicationName === null)
            throw new Error("The parameter 'applicationName' cannot be null.");
        else if (applicationName !== undefined)
            url_ += "applicationName=" + encodeURIComponent("" + applicationName) + "&";
        if (includePermissions === null)
            throw new Error("The parameter 'includePermissions' cannot be null.");
        else if (includePermissions !== undefined)
            url_ += "includePermissions=" + encodeURIComponent("" + includePermissions) + "&";
        if (includeRolePermissions === null)
            throw new Error("The parameter 'includeRolePermissions' cannot be null.");
        else if (includeRolePermissions !== undefined)
            url_ += "includeRolePermissions=" + encodeURIComponent("" + includeRolePermissions) + "&";
        if (includeExternalKeyPermissions === null)
            throw new Error("The parameter 'includeExternalKeyPermissions' cannot be null.");
        else if (includeExternalKeyPermissions !== undefined)
            url_ += "includeExternalKeyPermissions=" + encodeURIComponent("" + includeExternalKeyPermissions) + "&";
        if (includeUserGroups === null)
            throw new Error("The parameter 'includeUserGroups' cannot be null.");
        else if (includeUserGroups !== undefined)
            url_ += "includeUserGroups=" + encodeURIComponent("" + includeUserGroups) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserByClaim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserByClaim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserResponseModel>;
        }));
    }

    protected processGetUserByClaim(response: HttpResponseBase): Observable<UserResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUserGroupsByClaim(body?: UserClaimRequest | undefined): Observable<UserResponseModel> {
        let url_ = this.baseUrl + "/api/Users/groups/getbyclaim";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserGroupsByClaim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserGroupsByClaim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserResponseModel>;
        }));
    }

    protected processGetUserGroupsByClaim(response: HttpResponseBase): Observable<UserResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param application (optional) 
     * @param includeSuperAdmin (optional) 
     * @param body (optional) 
     * @return Success
     */
    getUsersList(application?: string | undefined, includeSuperAdmin?: boolean | undefined, body?: FilterRequest | undefined): Observable<UserWithRolesDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/Users/search?";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "application=" + encodeURIComponent("" + application) + "&";
        if (includeSuperAdmin === null)
            throw new Error("The parameter 'includeSuperAdmin' cannot be null.");
        else if (includeSuperAdmin !== undefined)
            url_ += "includeSuperAdmin=" + encodeURIComponent("" + includeSuperAdmin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWithRolesDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWithRolesDtoGridResponseBase>;
        }));
    }

    protected processGetUsersList(response: HttpResponseBase): Observable<UserWithRolesDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserWithRolesDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyName (optional) 
     * @return Success
     */
    getUserAssignedHierarchicalPermissions(userId: string, companyName?: string | undefined): Observable<HierarchicalPermissionDto> {
        let url_ = this.baseUrl + "/api/Users/v2/{userId}/permissions?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (companyName === null)
            throw new Error("The parameter 'companyName' cannot be null.");
        else if (companyName !== undefined)
            url_ += "companyName=" + encodeURIComponent("" + companyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedHierarchicalPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedHierarchicalPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HierarchicalPermissionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HierarchicalPermissionDto>;
        }));
    }

    protected processGetUserAssignedHierarchicalPermissions(response: HttpResponseBase): Observable<HierarchicalPermissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HierarchicalPermissionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export enum Action {
    None = "None",
    Success = "Success",
    Created = "Created",
    Accepted = "Accepted",
    Updated = "Updated",
    Deleted = "Deleted",
}

export class AddUserPermissionRequest implements IAddUserPermissionRequest {
    objectId?: string | undefined;
    permissions?: Permission[] | undefined;

    constructor(data?: IAddUserPermissionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(Permission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddUserPermissionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserPermissionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAddUserPermissionRequest {
    objectId?: string | undefined;
    permissions?: Permission[] | undefined;
}

export class AssignUserCompanyCommand implements IAssignUserCompanyCommand {
    userObjectId?: string;
    companies?: string[] | undefined;

    constructor(data?: IAssignUserCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userObjectId = _data["userObjectId"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(item);
            }
        }
    }

    static fromJS(data: any): AssignUserCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignUserCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userObjectId"] = this.userObjectId;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        return data;
    }
}

export interface IAssignUserCompanyCommand {
    userObjectId?: string;
    companies?: string[] | undefined;
}

export class AuditUserCommand implements IAuditUserCommand {
    auditLogId?: number;
    additionalDetails?: string | undefined;
    auditCategory?: string | undefined;
    companyCode?: string | undefined;
    applicationName?: string | undefined;
    userObjectId?: string;

    constructor(data?: IAuditUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditLogId = _data["auditLogId"];
            this.additionalDetails = _data["additionalDetails"];
            this.auditCategory = _data["auditCategory"];
            this.companyCode = _data["companyCode"];
            this.applicationName = _data["applicationName"];
            this.userObjectId = _data["userObjectId"];
        }
    }

    static fromJS(data: any): AuditUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AuditUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditLogId"] = this.auditLogId;
        data["additionalDetails"] = this.additionalDetails;
        data["auditCategory"] = this.auditCategory;
        data["companyCode"] = this.companyCode;
        data["applicationName"] = this.applicationName;
        data["userObjectId"] = this.userObjectId;
        return data;
    }
}

export interface IAuditUserCommand {
    auditLogId?: number;
    additionalDetails?: string | undefined;
    auditCategory?: string | undefined;
    companyCode?: string | undefined;
    applicationName?: string | undefined;
    userObjectId?: string;
}

export class CompanyDto implements ICompanyDto {
    companyId?: number;
    companyName?: string | undefined;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface ICompanyDto {
    companyId?: number;
    companyName?: string | undefined;
}

export class CompanyModel implements ICompanyModel {
    companyId?: number;
    name?: string | undefined;

    constructor(data?: ICompanyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICompanyModel {
    companyId?: number;
    name?: string | undefined;
}

export class CreateUserCommand implements ICreateUserCommand {
    email?: string | undefined;
    objectId?: string;
    roleName?: string[] | undefined;

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.objectId = _data["objectId"];
            if (Array.isArray(_data["roleName"])) {
                this.roleName = [] as any;
                for (let item of _data["roleName"])
                    this.roleName!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["objectId"] = this.objectId;
        if (Array.isArray(this.roleName)) {
            data["roleName"] = [];
            for (let item of this.roleName)
                data["roleName"].push(item);
        }
        return data;
    }
}

export interface ICreateUserCommand {
    email?: string | undefined;
    objectId?: string;
    roleName?: string[] | undefined;
}

export class ExternalKeyPermissionsModel implements IExternalKeyPermissionsModel {
    externalKeyTypePermissionsId?: number;
    externalKeyTypeCode?: string | undefined;
    roleId?: number;
    permissionId?: number;
    permission?: string | undefined;
    company?: string | undefined;
    companyId?: number;

    constructor(data?: IExternalKeyPermissionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalKeyTypePermissionsId = _data["externalKeyTypePermissionsId"];
            this.externalKeyTypeCode = _data["externalKeyTypeCode"];
            this.roleId = _data["roleId"];
            this.permissionId = _data["permissionId"];
            this.permission = _data["permission"];
            this.company = _data["company"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): ExternalKeyPermissionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalKeyPermissionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalKeyTypePermissionsId"] = this.externalKeyTypePermissionsId;
        data["externalKeyTypeCode"] = this.externalKeyTypeCode;
        data["roleId"] = this.roleId;
        data["permissionId"] = this.permissionId;
        data["permission"] = this.permission;
        data["company"] = this.company;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IExternalKeyPermissionsModel {
    externalKeyTypePermissionsId?: number;
    externalKeyTypeCode?: string | undefined;
    roleId?: number;
    permissionId?: number;
    permission?: string | undefined;
    company?: string | undefined;
    companyId?: number;
}

export class FilterRequest implements IFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;

    constructor(data?: IFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): FilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
}

export class GroupResponseModel implements IGroupResponseModel {
    groupId?: number;
    groupCode?: string | undefined;
    groupDescription?: string | undefined;

    constructor(data?: IGroupResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.groupCode = _data["groupCode"];
            this.groupDescription = _data["groupDescription"];
        }
    }

    static fromJS(data: any): GroupResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["groupCode"] = this.groupCode;
        data["groupDescription"] = this.groupDescription;
        return data;
    }
}

export interface IGroupResponseModel {
    groupId?: number;
    groupCode?: string | undefined;
    groupDescription?: string | undefined;
}

export class HierarchicalPermissionDto implements IHierarchicalPermissionDto {
    permissions?: string[] | undefined;
    deniedPermissions?: string[] | undefined;

    constructor(data?: IHierarchicalPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["deniedPermissions"])) {
                this.deniedPermissions = [] as any;
                for (let item of _data["deniedPermissions"])
                    this.deniedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): HierarchicalPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchicalPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.deniedPermissions)) {
            data["deniedPermissions"] = [];
            for (let item of this.deniedPermissions)
                data["deniedPermissions"].push(item);
        }
        return data;
    }
}

export interface IHierarchicalPermissionDto {
    permissions?: string[] | undefined;
    deniedPermissions?: string[] | undefined;
}

export class IResponse implements IIResponse {
    readonly isSuccess?: boolean;
    action?: Action;

    constructor(data?: IIResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isSuccess = _data["isSuccess"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): IResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["action"] = this.action;
        return data;
    }
}

export interface IIResponse {
    isSuccess?: boolean;
    action?: Action;
}

export class Permission implements IPermission {
    permissionId?: number;
    entity?: string | undefined;
    action?: string | undefined;
    scope?: string | undefined;
    applicationId?: number;
    readonly resourcePath?: string | undefined;

    constructor(data?: IPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionId = _data["permissionId"];
            this.entity = _data["entity"];
            this.action = _data["action"];
            this.scope = _data["scope"];
            this.applicationId = _data["applicationId"];
            (<any>this).resourcePath = _data["resourcePath"];
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionId"] = this.permissionId;
        data["entity"] = this.entity;
        data["action"] = this.action;
        data["scope"] = this.scope;
        data["applicationId"] = this.applicationId;
        data["resourcePath"] = this.resourcePath;
        return data;
    }
}

export interface IPermission {
    permissionId?: number;
    entity?: string | undefined;
    action?: string | undefined;
    scope?: string | undefined;
    applicationId?: number;
    resourcePath?: string | undefined;
}

export class PermissionsDto implements IPermissionsDto {
    permissionId?: number;
    permissionName?: string | undefined;

    constructor(data?: IPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionId = _data["permissionId"];
            this.permissionName = _data["permissionName"];
        }
    }

    static fromJS(data: any): PermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionId"] = this.permissionId;
        data["permissionName"] = this.permissionName;
        return data;
    }
}

export interface IPermissionsDto {
    permissionId?: number;
    permissionName?: string | undefined;
}

export class PermissionsModel implements IPermissionsModel {
    permissionId?: number;
    permissionName?: string | undefined;

    constructor(data?: IPermissionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionId = _data["permissionId"];
            this.permissionName = _data["permissionName"];
        }
    }

    static fromJS(data: any): PermissionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionId"] = this.permissionId;
        data["permissionName"] = this.permissionName;
        return data;
    }
}

export interface IPermissionsModel {
    permissionId?: number;
    permissionName?: string | undefined;
}

export class ResourceDto implements IResourceDto {
    resourceId?: number;
    parentId?: number | undefined;
    displayOrder?: number;
    resourceName?: string | undefined;
    code?: string | undefined;
    path?: string | undefined;
    cssClass?: string | undefined;
    display?: boolean;
    isAuthorized?: boolean;
    permissions?: PermissionsDto[] | undefined;

    constructor(data?: IResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.parentId = _data["parentId"];
            this.displayOrder = _data["displayOrder"];
            this.resourceName = _data["resourceName"];
            this.code = _data["code"];
            this.path = _data["path"];
            this.cssClass = _data["cssClass"];
            this.display = _data["display"];
            this.isAuthorized = _data["isAuthorized"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["parentId"] = this.parentId;
        data["displayOrder"] = this.displayOrder;
        data["resourceName"] = this.resourceName;
        data["code"] = this.code;
        data["path"] = this.path;
        data["cssClass"] = this.cssClass;
        data["display"] = this.display;
        data["isAuthorized"] = this.isAuthorized;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IResourceDto {
    resourceId?: number;
    parentId?: number | undefined;
    displayOrder?: number;
    resourceName?: string | undefined;
    code?: string | undefined;
    path?: string | undefined;
    cssClass?: string | undefined;
    display?: boolean;
    isAuthorized?: boolean;
    permissions?: PermissionsDto[] | undefined;
}

export class RoleAccessRightDto implements IRoleAccessRightDto {
    id?: number;
    accessRight?: string | undefined;

    constructor(data?: IRoleAccessRightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accessRight = _data["accessRight"];
        }
    }

    static fromJS(data: any): RoleAccessRightDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleAccessRightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accessRight"] = this.accessRight;
        return data;
    }
}

export interface IRoleAccessRightDto {
    id?: number;
    accessRight?: string | undefined;
}

export class RoleCompanyModel implements IRoleCompanyModel {
    companyId?: number;
    companyName?: string | undefined;

    constructor(data?: IRoleCompanyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): RoleCompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleCompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IRoleCompanyModel {
    companyId?: number;
    companyName?: string | undefined;
}

export class RoleIdDto implements IRoleIdDto {
    roleId?: number;

    constructor(data?: IRoleIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): RoleIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IRoleIdDto {
    roleId?: number;
}

export class RolePermissionsModel implements IRolePermissionsModel {
    resourceId?: number;
    parentId?: number | undefined;
    displayOrder?: number;
    resourceName?: string | undefined;
    code?: string | undefined;
    path?: string | undefined;
    cssClass?: string | undefined;
    display?: boolean;
    isAuthorized?: boolean;
    permissions?: PermissionsModel[] | undefined;

    constructor(data?: IRolePermissionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.parentId = _data["parentId"];
            this.displayOrder = _data["displayOrder"];
            this.resourceName = _data["resourceName"];
            this.code = _data["code"];
            this.path = _data["path"];
            this.cssClass = _data["cssClass"];
            this.display = _data["display"];
            this.isAuthorized = _data["isAuthorized"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RolePermissionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["parentId"] = this.parentId;
        data["displayOrder"] = this.displayOrder;
        data["resourceName"] = this.resourceName;
        data["code"] = this.code;
        data["path"] = this.path;
        data["cssClass"] = this.cssClass;
        data["display"] = this.display;
        data["isAuthorized"] = this.isAuthorized;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IRolePermissionsModel {
    resourceId?: number;
    parentId?: number | undefined;
    displayOrder?: number;
    resourceName?: string | undefined;
    code?: string | undefined;
    path?: string | undefined;
    cssClass?: string | undefined;
    display?: boolean;
    isAuthorized?: boolean;
    permissions?: PermissionsModel[] | undefined;
}

export class RoleResourcePermissionDto implements IRoleResourcePermissionDto {
    roleId?: number;
    roleName?: string | undefined;
    canImpersonate?: boolean;
    companies?: CompanyDto[] | undefined;
    resources?: ResourceDto[] | undefined;

    constructor(data?: IRoleResourcePermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.canImpersonate = _data["canImpersonate"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(CompanyDto.fromJS(item));
            }
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources!.push(ResourceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleResourcePermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleResourcePermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["canImpersonate"] = this.canImpersonate;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IRoleResourcePermissionDto {
    roleId?: number;
    roleName?: string | undefined;
    canImpersonate?: boolean;
    companies?: CompanyDto[] | undefined;
    resources?: ResourceDto[] | undefined;
}

export class RolesDetailDto implements IRolesDetailDto {
    roleId?: number;
    name?: string | undefined;
    isInternal?: boolean | undefined;
    canImpersonate?: boolean | undefined;
    canBeImpersonated?: boolean | undefined;
    description?: string | undefined;
    displayText?: string | undefined;
    isCustom?: boolean | undefined;
    applicationName?: string | undefined;

    constructor(data?: IRolesDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.name = _data["name"];
            this.isInternal = _data["isInternal"];
            this.canImpersonate = _data["canImpersonate"];
            this.canBeImpersonated = _data["canBeImpersonated"];
            this.description = _data["description"];
            this.displayText = _data["displayText"];
            this.isCustom = _data["isCustom"];
            this.applicationName = _data["applicationName"];
        }
    }

    static fromJS(data: any): RolesDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new RolesDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["name"] = this.name;
        data["isInternal"] = this.isInternal;
        data["canImpersonate"] = this.canImpersonate;
        data["canBeImpersonated"] = this.canBeImpersonated;
        data["description"] = this.description;
        data["displayText"] = this.displayText;
        data["isCustom"] = this.isCustom;
        data["applicationName"] = this.applicationName;
        return data;
    }
}

export interface IRolesDetailDto {
    roleId?: number;
    name?: string | undefined;
    isInternal?: boolean | undefined;
    canImpersonate?: boolean | undefined;
    canBeImpersonated?: boolean | undefined;
    description?: string | undefined;
    displayText?: string | undefined;
    isCustom?: boolean | undefined;
    applicationName?: string | undefined;
}

export class RolesModel implements IRolesModel {
    roleId?: number;
    roleName?: string | undefined;
    displayText?: string | undefined;
    isPrimary?: boolean;
    description?: string | undefined;
    isCustom?: boolean;
    isInternal?: boolean;
    canImpersonate?: boolean;
    canBeImpersonated?: boolean;
    applicationName?: string | undefined;
    roleCompanies?: RoleCompanyModel[] | undefined;
    externalKeyPermissions?: ExternalKeyPermissionsModel[] | undefined;
    resourcePermission?: RolePermissionsModel[] | undefined;

    constructor(data?: IRolesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.displayText = _data["displayText"];
            this.isPrimary = _data["isPrimary"];
            this.description = _data["description"];
            this.isCustom = _data["isCustom"];
            this.isInternal = _data["isInternal"];
            this.canImpersonate = _data["canImpersonate"];
            this.canBeImpersonated = _data["canBeImpersonated"];
            this.applicationName = _data["applicationName"];
            if (Array.isArray(_data["roleCompanies"])) {
                this.roleCompanies = [] as any;
                for (let item of _data["roleCompanies"])
                    this.roleCompanies!.push(RoleCompanyModel.fromJS(item));
            }
            if (Array.isArray(_data["externalKeyPermissions"])) {
                this.externalKeyPermissions = [] as any;
                for (let item of _data["externalKeyPermissions"])
                    this.externalKeyPermissions!.push(ExternalKeyPermissionsModel.fromJS(item));
            }
            if (Array.isArray(_data["resourcePermission"])) {
                this.resourcePermission = [] as any;
                for (let item of _data["resourcePermission"])
                    this.resourcePermission!.push(RolePermissionsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RolesModel {
        data = typeof data === 'object' ? data : {};
        let result = new RolesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["displayText"] = this.displayText;
        data["isPrimary"] = this.isPrimary;
        data["description"] = this.description;
        data["isCustom"] = this.isCustom;
        data["isInternal"] = this.isInternal;
        data["canImpersonate"] = this.canImpersonate;
        data["canBeImpersonated"] = this.canBeImpersonated;
        data["applicationName"] = this.applicationName;
        if (Array.isArray(this.roleCompanies)) {
            data["roleCompanies"] = [];
            for (let item of this.roleCompanies)
                data["roleCompanies"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.externalKeyPermissions)) {
            data["externalKeyPermissions"] = [];
            for (let item of this.externalKeyPermissions)
                data["externalKeyPermissions"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.resourcePermission)) {
            data["resourcePermission"] = [];
            for (let item of this.resourcePermission)
                data["resourcePermission"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IRolesModel {
    roleId?: number;
    roleName?: string | undefined;
    displayText?: string | undefined;
    isPrimary?: boolean;
    description?: string | undefined;
    isCustom?: boolean;
    isInternal?: boolean;
    canImpersonate?: boolean;
    canBeImpersonated?: boolean;
    applicationName?: string | undefined;
    roleCompanies?: RoleCompanyModel[] | undefined;
    externalKeyPermissions?: ExternalKeyPermissionsModel[] | undefined;
    resourcePermission?: RolePermissionsModel[] | undefined;
}

export class UnAssignUserCompanyCommand implements IUnAssignUserCompanyCommand {
    companies?: string[] | undefined;
    userObjectId?: string;

    constructor(data?: IUnAssignUserCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(item);
            }
            this.userObjectId = _data["userObjectId"];
        }
    }

    static fromJS(data: any): UnAssignUserCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UnAssignUserCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        data["userObjectId"] = this.userObjectId;
        return data;
    }
}

export interface IUnAssignUserCompanyCommand {
    companies?: string[] | undefined;
    userObjectId?: string;
}

export class UpsertUserCommandV2 implements IUpsertUserCommandV2 {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    suffix?: string | undefined;
    personId?: string | undefined;
    jobTitle?: string | undefined;
    objectId?: string;
    applicationName?: string | undefined;
    roles?: UserRoleRequestDto[] | undefined;
    companies?: string[] | undefined;
    groups?: string[] | undefined;

    constructor(data?: IUpsertUserCommandV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.suffix = _data["suffix"];
            this.personId = _data["personId"];
            this.jobTitle = _data["jobTitle"];
            this.objectId = _data["objectId"];
            this.applicationName = _data["applicationName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleRequestDto.fromJS(item));
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(item);
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
        }
    }

    static fromJS(data: any): UpsertUserCommandV2 {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUserCommandV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["suffix"] = this.suffix;
        data["personId"] = this.personId;
        data["jobTitle"] = this.jobTitle;
        data["objectId"] = this.objectId;
        data["applicationName"] = this.applicationName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        return data;
    }
}

export interface IUpsertUserCommandV2 {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    suffix?: string | undefined;
    personId?: string | undefined;
    jobTitle?: string | undefined;
    objectId?: string;
    applicationName?: string | undefined;
    roles?: UserRoleRequestDto[] | undefined;
    companies?: string[] | undefined;
    groups?: string[] | undefined;
}

export class UserAccessRightDto implements IUserAccessRightDto {
    routeUrl?: string | undefined;
    rolePermissions?: RoleAccessRightDto[] | undefined;

    constructor(data?: IUserAccessRightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeUrl = _data["routeUrl"];
            if (Array.isArray(_data["rolePermissions"])) {
                this.rolePermissions = [] as any;
                for (let item of _data["rolePermissions"])
                    this.rolePermissions!.push(RoleAccessRightDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserAccessRightDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccessRightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeUrl"] = this.routeUrl;
        if (Array.isArray(this.rolePermissions)) {
            data["rolePermissions"] = [];
            for (let item of this.rolePermissions)
                data["rolePermissions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUserAccessRightDto {
    routeUrl?: string | undefined;
    rolePermissions?: RoleAccessRightDto[] | undefined;
}

export class UserAccessRightsDto implements IUserAccessRightsDto {
    fullName?: string | undefined;
    id?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    userAccessRight?: UserAccessRightDto;
    impersonateUserCompanyCode?: string | undefined;
    stateOfResidenceId?: number;
    customRoleDisplayText?: string | undefined;
    primaryRoleId?: number;
    isHidden?: boolean;

    constructor(data?: IUserAccessRightsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.id = _data["id"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.userAccessRight = _data["userAccessRight"] ? UserAccessRightDto.fromJS(_data["userAccessRight"]) : <any>undefined;
            this.impersonateUserCompanyCode = _data["impersonateUserCompanyCode"];
            this.stateOfResidenceId = _data["stateOfResidenceId"];
            this.customRoleDisplayText = _data["customRoleDisplayText"];
            this.primaryRoleId = _data["primaryRoleId"];
            this.isHidden = _data["isHidden"];
        }
    }

    static fromJS(data: any): UserAccessRightsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccessRightsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["userAccessRight"] = this.userAccessRight ? this.userAccessRight.toJSON() : <any>undefined;
        data["impersonateUserCompanyCode"] = this.impersonateUserCompanyCode;
        data["stateOfResidenceId"] = this.stateOfResidenceId;
        data["customRoleDisplayText"] = this.customRoleDisplayText;
        data["primaryRoleId"] = this.primaryRoleId;
        data["isHidden"] = this.isHidden;
        return data;
    }
}

export interface IUserAccessRightsDto {
    fullName?: string | undefined;
    id?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    userAccessRight?: UserAccessRightDto;
    impersonateUserCompanyCode?: string | undefined;
    stateOfResidenceId?: number;
    customRoleDisplayText?: string | undefined;
    primaryRoleId?: number;
    isHidden?: boolean;
}

export class UserClaimRequest implements IUserClaimRequest {
    claimKey?: string | undefined;
    claimValue?: string | undefined;

    constructor(data?: IUserClaimRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimKey = _data["claimKey"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): UserClaimRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaimRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimKey"] = this.claimKey;
        data["claimValue"] = this.claimValue;
        return data;
    }
}

export interface IUserClaimRequest {
    claimKey?: string | undefined;
    claimValue?: string | undefined;
}

export class UserCompanyMappingDto implements IUserCompanyMappingDto {
    companyName?: string | undefined;
    roleId?: number;
    accessedOn?: Date | undefined;

    constructor(data?: IUserCompanyMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.roleId = _data["roleId"];
            this.accessedOn = _data["accessedOn"] ? new Date(_data["accessedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserCompanyMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCompanyMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["roleId"] = this.roleId;
        data["accessedOn"] = this.accessedOn ? this.accessedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserCompanyMappingDto {
    companyName?: string | undefined;
    roleId?: number;
    accessedOn?: Date | undefined;
}

export class UserDto implements IUserDto {
    objectId?: string | undefined;
    email?: string | undefined;
    roleNames?: string[] | undefined;
    createdBy?: string | undefined;
    createdOn?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            this.email = _data["email"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        data["email"] = this.email;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn;
        return data;
    }
}

export interface IUserDto {
    objectId?: string | undefined;
    email?: string | undefined;
    roleNames?: string[] | undefined;
    createdBy?: string | undefined;
    createdOn?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: string | undefined;
}

export class UserGroupModel implements IUserGroupModel {
    userGroupId?: number;
    userGroupCode?: string | undefined;

    constructor(data?: IUserGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGroupId = _data["userGroupId"];
            this.userGroupCode = _data["userGroupCode"];
        }
    }

    static fromJS(data: any): UserGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGroupId"] = this.userGroupId;
        data["userGroupCode"] = this.userGroupCode;
        return data;
    }
}

export interface IUserGroupModel {
    userGroupId?: number;
    userGroupCode?: string | undefined;
}

export class UserPermissionDto implements IUserPermissionDto {
    userScreenPermission?: UserResourcePermissionDto;
    userAccessRights?: UserAccessRightsDto;

    constructor(data?: IUserPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userScreenPermission = _data["userScreenPermission"] ? UserResourcePermissionDto.fromJS(_data["userScreenPermission"]) : <any>undefined;
            this.userAccessRights = _data["userAccessRights"] ? UserAccessRightsDto.fromJS(_data["userAccessRights"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userScreenPermission"] = this.userScreenPermission ? this.userScreenPermission.toJSON() : <any>undefined;
        data["userAccessRights"] = this.userAccessRights ? this.userAccessRights.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserPermissionDto {
    userScreenPermission?: UserResourcePermissionDto;
    userAccessRights?: UserAccessRightsDto;
}

export class UserPermissionsModel implements IUserPermissionsModel {
    resourceId?: number;
    parentId?: number | undefined;
    displayOrder?: number;
    resourceName?: string | undefined;
    code?: string | undefined;
    path?: string | undefined;
    cssClass?: string | undefined;
    display?: boolean;
    isAuthorized?: boolean;
    permissions?: PermissionsModel[] | undefined;

    constructor(data?: IUserPermissionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.parentId = _data["parentId"];
            this.displayOrder = _data["displayOrder"];
            this.resourceName = _data["resourceName"];
            this.code = _data["code"];
            this.path = _data["path"];
            this.cssClass = _data["cssClass"];
            this.display = _data["display"];
            this.isAuthorized = _data["isAuthorized"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPermissionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["parentId"] = this.parentId;
        data["displayOrder"] = this.displayOrder;
        data["resourceName"] = this.resourceName;
        data["code"] = this.code;
        data["path"] = this.path;
        data["cssClass"] = this.cssClass;
        data["display"] = this.display;
        data["isAuthorized"] = this.isAuthorized;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUserPermissionsModel {
    resourceId?: number;
    parentId?: number | undefined;
    displayOrder?: number;
    resourceName?: string | undefined;
    code?: string | undefined;
    path?: string | undefined;
    cssClass?: string | undefined;
    display?: boolean;
    isAuthorized?: boolean;
    permissions?: PermissionsModel[] | undefined;
}

export class UserResourcePermissionDto implements IUserResourcePermissionDto {
    userId?: number;
    userName?: string | undefined;
    roles?: RoleResourcePermissionDto[] | undefined;
    objectId?: string;

    constructor(data?: IUserResourcePermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleResourcePermissionDto.fromJS(item));
            }
            this.objectId = _data["objectId"];
        }
    }

    static fromJS(data: any): UserResourcePermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserResourcePermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : <any>undefined);
        }
        data["objectId"] = this.objectId;
        return data;
    }
}

export interface IUserResourcePermissionDto {
    userId?: number;
    userName?: string | undefined;
    roles?: RoleResourcePermissionDto[] | undefined;
    objectId?: string;
}

export class UserResponseModel implements IUserResponseModel {
    userId?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    suffix?: string | undefined;
    personId?: string | undefined;
    jobTitle?: string | undefined;
    objectId?: string;
    applicationName?: string | undefined;
    claims?: { [key: string]: string; } | undefined;
    companies?: CompanyModel[] | undefined;
    groups?: UserGroupModel[] | undefined;
    roles?: RolesModel[] | undefined;
    resources?: UserPermissionsModel[] | undefined;

    constructor(data?: IUserResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.suffix = _data["suffix"];
            this.personId = _data["personId"];
            this.jobTitle = _data["jobTitle"];
            this.objectId = _data["objectId"];
            this.applicationName = _data["applicationName"];
            if (_data["claims"]) {
                this.claims = {} as any;
                for (let key in _data["claims"]) {
                    if (_data["claims"].hasOwnProperty(key))
                        (<any>this.claims)![key] = _data["claims"][key];
                }
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(CompanyModel.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(UserGroupModel.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RolesModel.fromJS(item));
            }
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources!.push(UserPermissionsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["suffix"] = this.suffix;
        data["personId"] = this.personId;
        data["jobTitle"] = this.jobTitle;
        data["objectId"] = this.objectId;
        data["applicationName"] = this.applicationName;
        if (this.claims) {
            data["claims"] = {};
            for (let key in this.claims) {
                if (this.claims.hasOwnProperty(key))
                    (<any>data["claims"])[key] = (<any>this.claims)[key];
            }
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUserResponseModel {
    userId?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    suffix?: string | undefined;
    personId?: string | undefined;
    jobTitle?: string | undefined;
    objectId?: string;
    applicationName?: string | undefined;
    claims?: { [key: string]: string; } | undefined;
    companies?: CompanyModel[] | undefined;
    groups?: UserGroupModel[] | undefined;
    roles?: RolesModel[] | undefined;
    resources?: UserPermissionsModel[] | undefined;
}

export class UserRoleDto implements IUserRoleDto {
    roleId?: number;
    isPrimary?: boolean;
    roleName?: string | undefined;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.isPrimary = _data["isPrimary"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["isPrimary"] = this.isPrimary;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserRoleDto {
    roleId?: number;
    isPrimary?: boolean;
    roleName?: string | undefined;
}

export class UserRoleRequestDto implements IUserRoleRequestDto {
    isPrimary?: boolean;
    roleName?: string | undefined;

    constructor(data?: IUserRoleRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPrimary = _data["isPrimary"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserRoleRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPrimary"] = this.isPrimary;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserRoleRequestDto {
    isPrimary?: boolean;
    roleName?: string | undefined;
}

export class UserWithRolesDto implements IUserWithRolesDto {
    userId?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    suffix?: string | undefined;
    personId?: string | undefined;
    jobTitle?: string | undefined;
    applicationName?: string | undefined;
    objectId?: string;
    isHavingRole?: boolean;
    roles?: RolesDetailDto[] | undefined;

    constructor(data?: IUserWithRolesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.suffix = _data["suffix"];
            this.personId = _data["personId"];
            this.jobTitle = _data["jobTitle"];
            this.applicationName = _data["applicationName"];
            this.objectId = _data["objectId"];
            this.isHavingRole = _data["isHavingRole"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RolesDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserWithRolesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserWithRolesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["suffix"] = this.suffix;
        data["personId"] = this.personId;
        data["jobTitle"] = this.jobTitle;
        data["applicationName"] = this.applicationName;
        data["objectId"] = this.objectId;
        data["isHavingRole"] = this.isHavingRole;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUserWithRolesDto {
    userId?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    suffix?: string | undefined;
    personId?: string | undefined;
    jobTitle?: string | undefined;
    applicationName?: string | undefined;
    objectId?: string;
    isHavingRole?: boolean;
    roles?: RolesDetailDto[] | undefined;
}

export class UserWithRolesDtoGridResponseBase implements IUserWithRolesDtoGridResponseBase {
    items?: UserWithRolesDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: UserWithRolesDto;

    constructor(data?: IUserWithRolesDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserWithRolesDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? UserWithRolesDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserWithRolesDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new UserWithRolesDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserWithRolesDtoGridResponseBase {
    items?: UserWithRolesDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: UserWithRolesDto;
}

export class UsersResponse implements IUsersResponse {
    userId?: string;

    constructor(data?: IUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUsersResponse {
    userId?: string;
}

export class UsersRolesDto implements IUsersRolesDto {
    roleId?: number;
    roleName?: string | undefined;
    isInternal?: boolean | undefined;
    canImpersonate?: boolean | undefined;
    canBeImpersonated?: boolean | undefined;
    rolesDescription?: string | undefined;
    roleDisplayText?: string | undefined;
    isCustom?: boolean | undefined;
    applicationName?: string | undefined;
    companies?: string[] | undefined;
    isPrimary?: boolean;

    constructor(data?: IUsersRolesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.isInternal = _data["isInternal"];
            this.canImpersonate = _data["canImpersonate"];
            this.canBeImpersonated = _data["canBeImpersonated"];
            this.rolesDescription = _data["rolesDescription"];
            this.roleDisplayText = _data["roleDisplayText"];
            this.isCustom = _data["isCustom"];
            this.applicationName = _data["applicationName"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(item);
            }
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any): UsersRolesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsersRolesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["isInternal"] = this.isInternal;
        data["canImpersonate"] = this.canImpersonate;
        data["canBeImpersonated"] = this.canBeImpersonated;
        data["rolesDescription"] = this.rolesDescription;
        data["roleDisplayText"] = this.roleDisplayText;
        data["isCustom"] = this.isCustom;
        data["applicationName"] = this.applicationName;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        data["isPrimary"] = this.isPrimary;
        return data;
    }
}

export interface IUsersRolesDto {
    roleId?: number;
    roleName?: string | undefined;
    isInternal?: boolean | undefined;
    canImpersonate?: boolean | undefined;
    canBeImpersonated?: boolean | undefined;
    rolesDescription?: string | undefined;
    roleDisplayText?: string | undefined;
    isCustom?: boolean | undefined;
    applicationName?: string | undefined;
    companies?: string[] | undefined;
    isPrimary?: boolean;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}